// extracted by mini-css-extract-plugin
export default {"selectcss":"Paginator_selectcss__ukO47"};